// extracted by mini-css-extract-plugin
export default {"formColumn":"FormColumn_formColumn__mjoxO"};